// extracted by mini-css-extract-plugin
module.exports = {"container":"provisionRow_container__V2-za","rowMarginBottom":"provisionRow_rowMarginBottom__2D0LR","col":"provisionRow_col__eOOT0"};